<template>
    <router-link :to="{ name: routeName, params: routeParams }" :title="text.export + ' ' + linkName">{{text.export}}</router-link>
</template>

<script>
    import lang from "@/shared/lang";

    export default {
        name: "ExportAction",
        props: {
            routeName: {
                type: String
            },
            routeParams: {
                type: Object
            },
            linkName: {
                type: String
            }
        },
        computed: {
            text() {
                return lang;
            },
        },
    }
</script>